// extracted by mini-css-extract-plugin
module.exports = {"articles__grid":"article-category_articles__grid__b2Xl0","filters":"article-category_filters__DpCXU"};